/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./create-project-dialog.vue?vue&type=template&id=32bc0884&"
import script from "./create-project-dialog.vue?vue&type=script&lang=ts&"
export * from "./create-project-dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports